import React from 'react';
import { Button } from 'antd';

import { downloadFileByObjectURL } from 'utils/fileUtils';
import BaseAlert from 'components/wrappers/BaseAlert/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import {
  getAssignmentsDetailExcel,
  getPartnerAssignmentExcel,
} from 'redux/reducers/assignmentSlice';
import { AssignmentStatusTypeEnum } from 'api/adminApiClient';
import { useAppSelector } from 'hooks/useAppSelector';
import { useAppDispatch } from 'hooks/useAppDispatch';

import styles from '../AssignmentDetailsPage.module.less';

type Props = {
  assignmentId?: string;
  assignmentStatus?: number;
  isPartner?: boolean;
};

export default function DownloadAssignment(props: Props) {
  const { assignmentId, assignmentStatus, isPartner } = props;
  const isAdminRole = useAppSelector(isAdminSelector);
  const dispatch = useAppDispatch();

  const handleDownloadAssignment = async () => {
    const correctAction = isPartner
      ? getPartnerAssignmentExcel
      : getAssignmentsDetailExcel;

    const result = await dispatch(
      correctAction({
        assignmentId,
        isAdminRole,
      }),
    );

    if (correctAction.fulfilled.match(result)) {
      downloadFileByObjectURL(result.payload.url, result.payload.fileName);
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const getDownloadButton = () => {
    if (
      assignmentStatus === AssignmentStatusTypeEnum.Active ||
      assignmentStatus === AssignmentStatusTypeEnum.Completed ||
      isPartner
    ) {
      return (
        <div>
          <Button
            className={styles.downloadBtn}
            onClick={handleDownloadAssignment}
            icon={<span className="icon icon-xls-file" />}
          />
        </div>
      );
    }

    return null;
  };

  return <>{getDownloadButton()}</>;
}
